const isFlutterWebView = navigator.userAgent.includes('com.fleetmap.jsrastreamento');

export function useIsFlutterWebView() {
  return isFlutterWebView;
}
